<template>
  <div class="wrapper">
    <div class="wrapper-header">
      <TabsWidget activeTab="streaming_location" @selected="switchTab"></TabsWidget>
      <div class="tab-options">
        <b-button type="is-primary" outlined @click="newLocation()">NEW LOCATION</b-button>
      </div>
    </div>
    <div class="wrapper-body">
      <div class="left-panel">
        <div v-if="!loading_location && location_data.length > 0" class="table-widget">
          <table>
            <tr>
              <th>Location</th>
              <th>Status</th>
              <th></th>
            </tr>
            <tr v-for="(item, index) in location_data" :key="index">
              <td>{{ item.location_name }}</td>
              <td>
                <b-tag v-if="item.status == 'published'" type="is-success">Published</b-tag>
                <b-tag v-if="item.status == 'pending'" type="is-warning">Draft</b-tag>
              </td>
              <td>
                <b-dropdown aria-role="list" class="is-pulled-right" position="is-bottom-left">
                  <template #trigger>
                    <b-icon icon="dots-vertical"></b-icon>
                  </template>
                  <b-dropdown-item @click="updateLocation(item)" aria-role="listitem">Update</b-dropdown-item>
                  <b-dropdown-item @click="deleteLocation(item.id, index)" aria-role="listitem">Delete</b-dropdown-item>
                </b-dropdown>
              </td>
            </tr>
          </table>
        </div>

        <div v-if="loading_location" class="table-widget">
          <table>
            <tr>
              <th>Location</th>
              <th>Status</th>
              <th></th>
            </tr>
            <tr v-for="(item, index) in 15" :key="index">
              <td><b-skeleton width="90%"></b-skeleton></td>
              <td><b-skeleton width="90%"></b-skeleton></td>
              <td><b-skeleton width="90%"></b-skeleton></td>
              <td><b-skeleton width="90%"></b-skeleton></td>
              <td><b-skeleton width="90%"></b-skeleton></td>
            </tr>
          </table>
        </div>
        <div v-if="!loading_location && location_data.length == 0" class="table-widget">
          <widgetNotfound title="No Location Found" subtitle="You have not added any location yet."></widgetNotfound>
        </div>
      </div>
      <div class="rigth-panel"></div>
    </div>

    <!-- Add Location Modal -->
    <addStreamLocationModal v-if="show_add_location_modal" :content="selected_item" @success="onAddStreamLocation"
      @close="show_add_location_modal = false"></addStreamLocationModal>
  </div>
</template>

<script>
import addStreamLocationModal from "./modals/add_stream_location_modal.vue";
import TabsWidget from "./components/TabsWidget.vue";
export default {
  components: {
    addStreamLocationModal,
    TabsWidget,
  },
  sockets: {},
  data: () => ({
    loading_location: false,
    show_add_location_modal: false,
    location_data: [],
    selected_item: null,
  }),

  mounted() {
    let vm = this;
    vm.getAllStreamLocation();
  },
  methods: {
    onAddStreamLocation() {
      let vm = this;
      vm.show_add_location_modal = false;
      vm.getAllStreamLocation();
    },
    deleteLocation(id, index) {
      let vm = this;
      vm.$confirm({
        title: "Confirm",
        message: `Are you sure?`,
        button: {
          no: "No",
          yes: "Yes",
        },
        callback: (confirm) => {
          if (confirm) {
            vm.$store
              .dispatch("STREAMING_DELETE_STREAM_LOCATION", { id: id })
              .then((response) => {
                vm.location_data.splice(index, 1);
                vm.$notify({
                  group: "status",
                  type: "success",
                  title: "Important message",
                  text: response.data.message,
                });
              })
              .catch(({ response }) => {
                vm.$notify({
                  group: "status",
                  type: "warn",
                  title: "OOPS!!!",
                  text: response.data.message,
                });
              });
          }
        },
      });
    },
    updateLocation(item) {
      let vm = this;
      vm.selected_item = item;
      vm.show_add_location_modal = true;
    },
    getAllStreamLocation() {
      let vm = this;
      vm.$store
        .dispatch("STREAMING_GET_ALL_STREAM_LOCATION")
        .then((response) => {
          vm.location_data = response.data.return;
        })
        .catch(({ response }) => { });
    },
    newLocation() {
      let vm = this;
      vm.selected_item = null;
      vm.show_add_location_modal = true;
    },
    switchTab(type) {
      let vm = this;
      vm.$emit("tab", type);
    },
  },
};
</script>
<style lang="scss" scoped>
.wrapper {
  padding: 0px;
  display: flex;
  flex-direction: column;
  height: 100%;

  .wrapper-header {
    width: 100%;
    height: 60px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #ddd;
    overflow-x: auto;

    .tabs-widget {
      display: flex;
      align-items: flex-end;

      .h-spacer {
        margin-right: 20px;
      }

      .tab-item {
        cursor: pointer;
        padding: 14px 4px;
        white-space: nowrap;

        &.active {
          color: var(--wecodefy-secondary-color, #9fc953);
          border-bottom: 3px solid var(--wecodefy-secondary-color, #9fc953);
        }
      }
    }

    .tab-options {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0px 10px;

      .h-spacer {
        margin-right: 10px;
      }
    }
  }

  .wrapper-body {
    height: calc(100% - 60px);
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    .left-panel {
      height: 100%;
      width: calc(100% - 0px);
      background: #fff;
      display: flex;
      flex-direction: column;

      .left-panel-header {
        height: 60px;
        display: flex;
        align-items: center;
        border-bottom: 1px solid #ddd;
        justify-content: flex-end;
        padding: 0px 15px;
      }

      .table-widget {
        overflow-y: auto;
        height: calc(100% - 60px);
      }
    }

    .rigth-panel {
      width: 0px;
      height: 100%;
      background: #fff;
      border-left: 1px solid #ddd;
      display: flex;
      flex-direction: column;

      .right-panel-header {
        height: 60px;
        display: flex;
        align-items: center;
        padding: 0px 10px;
        border-bottom: 1px solid #ddd;
      }
    }
  }
}
</style>
